const withRetry = async <T>(operation: () => Promise<T>, retryCount: number) => {
  try {
    return await operation()
  } catch (error) {
    if (retryCount !== 0) {
      const result: T = await withRetry(operation, retryCount - 1)
      return result
    }
    throw error
  }
}

export default withRetry
